export default "__VITE_ASSET__3cb1cdb0__"